/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */

import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IValidacionProducto from './entidades/validacionProducto';

export default class ModeloCargarPlantilla {
    public async CargarPlantillaProducto(formData: FormData) {
        return manejadorRest<IRespuesta<IValidacionProducto>>(
            () => negocio.post('ProcesarArchivo/CargarPlantillaProducto', formData),
            true
        );
    }

    public async CargarPlantillaInventario(formData: FormData) {
        return manejadorRest<IRespuesta<IValidacionProducto>>(
            () => negocio.post('CargaMasivaInventario/CargarPlantilla', formData),
            true
        );
    }

    

    
}
